// extracted by mini-css-extract-plugin
module.exports = {"special":"liveEventSpecial-module--special--2_VgE","img":"liveEventSpecial-module--img--ZhjNO"};